import React from 'react'
import {
  Box,
  Grid,
  IconButton,
  TextField,
  MenuItem,
  Select,  
  FormControl,
  FormHelperText,
} from '@mui/material';
import { useFormikContext, getIn } from "formik";

import DeleteIcon from '@mui/icons-material/Delete';
import MultiUploadComponent from '../../common/form/MultiUploadComponent';

const EstimateMultiFileForm = ({ file, index, touched, errors, handleRemove, handleChange, handleBlur }) => {
    const formikProps = useFormikContext();

  //console.log(formikProps,'form')

  
  const fileVal = `files[${index}].file`;
  const touchedFile = getIn(touched, fileVal);
  const errorFile = getIn(errors, fileVal);

  const fileTyp = `files[${index}].fileTyp`;

  const fileDesc = `files[${index}].fileDesc`;
  const touchedFileDesc = getIn(touched, fileDesc);
  const errorFileDesc = getIn(errors, fileDesc);


  return (
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      marginTop: 2,
      px: 2,
    }}

  >
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={1}
    >

    <Grid item sx={3}> 
     <FormControl sx={{ m: 1 }} variant="standard">
      <Select
            // labelId="demo-simple-select-standard-label"
            name={fileTyp}
            id={fileTyp}
            onChange={handleChange}
            label="파일종류"
            defaultValue="매출견적서"
            value={formikProps.values.files[index].fileTyp}
            displayEmpty      // 빈 값일 때도 placeholder처럼 보이게
            renderValue={(selected) =>
              selected || <em>파일종류 선택</em>
            }
          >
            {/* <MenuItem value="">
              <em>None</em>
            </MenuItem> */}
            <MenuItem value="매출견적서">매출견적서</MenuItem>
            <MenuItem value="매입견적서">매입견적서</MenuItem>
          </Select> 
      </FormControl>
    </Grid> 
      <Grid item xs={4}>
      <MultiUploadComponent index={index} formik={formikProps} />
        {touchedFile && Boolean(errorFile) && (
          <FormControl error>
            <FormHelperText>
              {touchedFile && errorFile}
            </FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid item xs={5}>

            <TextField
              variant="standard"
              fullWidth
              name={fileDesc}
              id={fileDesc}
              value={formikProps.values.files[index].fileDesc}
              helperText={
                touchedFileDesc && errorFileDesc
                  ? errorFileDesc
                  : ""
              }
              error={Boolean(touchedFileDesc && errorFileDesc)}
              onChange={handleChange}
              onBlur={handleBlur}
              label="참고사항"

            />
          </Grid>
      <Grid item xs={1}><IconButton aria-label="delete" onClick={handleRemove}><DeleteIcon /></IconButton></Grid>
    </Grid>

  </Box>
  )
}

export default EstimateMultiFileForm